// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutSuccess_wrapper__EJD6j","button":"CheckoutSuccess_button__Lq4Y3","icon":"CheckoutSuccess_icon__BHKqY"};